const PIECE_TYPES = {
  Documents: 0,
  NonDocuments: 1,
};

export default PIECE_TYPES;
